const accordionItems = document.querySelectorAll('.accordion-item');

accordionItems.forEach(item => {
  const header = item.querySelector('.accordion-header');
  const content = item.querySelector('.accordion-content');
  
  header.addEventListener('click', function() {
    // Toggle active class
    const isActive = item.classList.contains('active');
    
    // Close all accordions
    accordionItems.forEach(i => {
      i.classList.remove('active');
      i.querySelector('.accordion-content').style.maxHeight = '0';
    });
    
    // If clicked item wasn't active, open it
    if (!isActive) {
      item.classList.add('active');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
});